import { createSlice } from "@reduxjs/toolkit";

const getStoredTimezone = () => {
  if (typeof window === "undefined") return "";
  return window.localStorage.getItem("selectedTimezone") || null;
};

const globalDataSlice = createSlice({
  name: "data",
  initialState: {
    enums: null,
    configs: null,
    timezone: getStoredTimezone() ?? null,
    userRoles: null,

  },
  reducers: {
    setEnums: (state, action) => {
      state.enums = action.payload;
    },
    clearEnums: (state) => {
      state.enums = null;
    },
    setConfigs: (state, action) => {
      state.configs = action.payload;
    },
    clearConfigs: (state) => {
      state.configs = null;
    },
    setTimezone: (state, action) => {
      state.timezone = action.payload;
    },
    setUserRoles: (state, action) => {
      state.userRoles = action.payload;
    }
  }
});

export const { setEnums, clearEnums, setConfigs, clearConfigs, setTimezone, setUserRoles } = globalDataSlice.actions;
export default globalDataSlice.reducer;
